import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

AdminGuard.propTypes = {
  children: PropTypes.node,
};

export default function AdminGuard({ children }) {
  const { user, role } = useAuth();

  if (!user || role !== "admin") {
    return <Navigate to={"/login"} />;
  }

  return <>{children}</>;
}
